import React from 'react'
import { SelectField, SelectFieldProps, OptionStyled } from '@mobi/component-library/Legacy/Select'
import { useCountryList } from '@mobi/account/Areas/SignUp/Hooks'
import {
  PopularCountryList,
  AlphabeticalCountryList,
} from '@mobi/account/Common/CountryOptionGroups'

export const CountrySelect = ({ ...props }: SelectFieldProps) => {
  const { isLoading, isError, data: countries } = useCountryList()

  return (
    <SelectField {...props}>
      {isLoading && <OptionStyled value=''>Loading ...</OptionStyled>}

      {isError && <OptionStyled value=''>Could not load countries</OptionStyled>}

      {!isLoading && !isError && countries && (
        <>
          <OptionStyled value=''>Select a country</OptionStyled>
          <PopularCountryList countries={countries} />
          <AlphabeticalCountryList countries={countries} />
        </>
      )}
    </SelectField>
  )
}
